import styled from 'styled-components';

export const Center = styled.div.attrs({ 'data-component': 'Center' })`
  display: flex;
  align-items: center;
  justify-content: center;
`;
